import type { PageName } from 'src/core/utils/pageUtil';

export const getThreadId = (
  pageName: PageName,
  params?: Record<string, string | undefined>,
): string => {
  if (pageName === 'CommunityThreadDetails' && params?.threadSlug) {
    return params?.threadSlug?.split('-')?.at(-1) || '';
  }
  return '';
};
